/* eslint-disable react/prop-types */
import React from 'react';
import { FormattedMessage } from 'react-intl';

import './TimeLine.css';

export function TimeLine(props) {
  const { timeInformation, conference, buttonInformation } = props;

  return (
    <div className="timeline-wrap">
      {conference ? (
        <div className="Conference-text">
          <FormattedMessage id="Conference" />
        </div>
      ) : (
        <div className="Conference-text"></div>
      )}
      <button className={`Conference-btn ${buttonInformation.className}`}>
        <FormattedMessage id={buttonInformation.name} />
      </button>
      <div className="TimeLine">
        <div className="TimeLine-Left">
          {timeInformation.map((item) => {
            return item.left ? (
              <div className="TimeLine-Left-item">
                {item.left.edmontionTime ? (
                  <div className="font-style-Edmonton">
                    <FormattedMessage id="EdmontionTime" />
                    <span className="font-style-time">
                      {item.left.edmontionTime}
                    </span>
                  </div>
                ) : (
                  ''
                )}
                {item.left.chinaTime ? (
                  <div className="font-style-Edmonton">
                    <FormattedMessage id="ChinaTime" />
                    <span className="font-style-Chaintime">
                      {item.left.chinaTime}
                    </span>
                  </div>
                ) : (
                  ''
                )}
                {item.left.freeTime ? (
                  <div className="font-style-freeTime">
                    {item.left.freeTime}
                  </div>
                ) : (
                  ''
                )}
              </div>
            ) : (
              ''
            );
          })}
        </div>
        <div className="TimeLine-line"></div>
        <div className="TimeLine-right">
          {timeInformation.map((item, i) => (
            <div key={i} className="TimeLine-right-item">
              {item.right.img ? (
                <div className="icon-img"></div>
              ) : (
                <div className="icon-block"></div>
              )}
              {item.right.state ? (
                <div className="TimeLine-description-color">
                  {item.right.description}
                </div>
              ) : (
                <div className="TimeLine-description">
                  {item.right.description}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
